export default __webpack_public_path__ + "static/media/links-aini2018.a9a2f0f3.png";